import React from "react"
import ReactPlayer from "react-player/youtube"
import PlayIcon from "../../assets/svg/PlatyIcon.svg"
import styled from "styled-components"


const StyledPlayer = styled(ReactPlayer)`
  width: 100%;
  height: unset;
  aspect-ratio: ${({aspectRatio}) => aspectRatio};
`

const VideoPlayer = ({ url, aspectRatio, height = 280 }) => {
  return (
    <>
      <StyledPlayer
        aspectRatio={aspectRatio}
        light
        width='100%'
        height={height}
        url={url}
        playIcon={<PlayIcon />}
      />
    </>
  )
}

export default VideoPlayer
